import React from 'react'
import { useTimelineStyles } from '../../../hooks/use-timeline-styles'

export const TimelineHoverLine = ({ x, show }) => {
  const { TimelineStyles } = useTimelineStyles()

  if (!show) return null

  return (
    <line
      x1={x}
      y1={0}
      x2={x}
      y2="100%"
      stroke={TimelineStyles.hover.fillColor}
      strokeWidth={TimelineStyles.hover.width}
      strokeDasharray="4 3"
      style={{ pointerEvents: 'none' }}
    />
  )
}
